/**
 * 한국어 콘텐츠 카탈로그 — `auth` 기능 (로그인, 가입, 마법 링크 인증,
 * 비밀번호 초기화 / 설정). 키는 `packages/@gamecodex/world-ui/src/features/auth/*`
 * 내 `t('auth.*')` 호출과 1:1 대응. 값은 정확한 한국어 번역.
 */
export const authKo = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Grymwyrd 홈',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Google로 계속하기',
  'auth.oauth.continueWithDiscord': 'Discord로 계속하기',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': '로그인 중',
  'auth.verify.seoDescription': 'Grymwyrd 로그인 링크를 확인하는 중입니다.',
  'auth.verify.errorMissingToken':
    '로그인 링크에 토큰이 없습니다. 로그인 페이지에서 새 링크를 요청해주세요.',
  'auth.verify.errorInvalidOrExpired':
    '로그인 링크가 유효하지 않거나 만료되었습니다. 로그인 페이지에서 새 링크를 요청해주세요.',
  'auth.verify.confirming': '로그인을 확인하는 중…',
  'auth.verify.signedInHeading': '로그인되었습니다',
  'auth.verify.signedInAsPrefix': '로그인:',
  'auth.verify.signedInAsSuffix': '. 성역으로 안내하는 중…',
  'auth.verify.takingYouToSanctum': '성역으로 안내하는 중…',
  'auth.verify.goNow': '지금 이동',
  'auth.verify.problemHeading': '로그인 링크 문제',
  'auth.verify.backToSignIn': '로그인으로 돌아가기',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': '위에서 이메일을 입력하고 링크를 요청해주세요.',
  'auth.login.seoTitle': '한계를 넘다',
  'auth.login.seoDescription': 'Grymwyrd에 로그인하고 영원한 황혼 속 당신의 전설로 돌아오세요.',
  'auth.login.eyebrow': '돌아오세요, 방랑자',
  'auth.login.title': '한계를 넘다',
  'auth.login.blurb': '이름과 비밀의 말을 전하고 영원한 황혼으로 돌아오세요.',
  'auth.login.noPactYet': '아직 계약이 없으신가요?',
  'auth.login.forgeYourLegend': '당신의 전설을 만들다',
  'auth.login.emailLabel': '이메일',
  'auth.login.emailPlaceholder': 'you@grymwyrd.com',
  'auth.login.passwordLabel': '비밀번호',
  'auth.login.forgotPassword': '비밀번호를 잊으셨나요?',
  'auth.login.submitBusy': '진입하는 중…',
  'auth.login.submit': '들어가기',
  'auth.login.dividerOr': '또는',
  'auth.login.magicSentPrefix': '로그인 링크가 발송되었습니다',
  'auth.login.magicSentTo': '받는 주소:',
  'auth.login.magicSentSuffix': '. 받은 편지함을 확인해주세요.',
  'auth.login.emailMeSignInLink': '로그인 링크를 이메일로 받기',
  'auth.login.mockAuthPrefix': '개발용 모의 인증: 모든 이메일 가능. 사용:',
  'auth.login.mockAuthOr': '또는',
  'auth.login.mockAuthSuffix': '상위 권한을 위해.',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': '당신의 전설이 전해질 이름을 선택해주세요.',
  'auth.register.errorEmailRequired': '계약을 봉인하려면 이메일이 필요합니다.',
  'auth.register.errorEmailInvalid': '이메일 주소가 올바르지 않습니다.',
  'auth.register.errorPasswordTooShort': '비밀의 말은 최소 8자 이상이어야 합니다.',
  'auth.register.errorMustBeAdult': 'Grymwyrd에 참여하려면 13세 이상이어야 합니다.',
  'auth.register.errorMustAcceptTerms': '계약(약관)에 동의해야 계속할 수 있습니다.',
  'auth.register.errorIncomplete': '계약서의 일부 항목이 완료되지 않았습니다. 아래를 확인해주세요.',
  'auth.register.seoTitle': '당신의 이야기를 시작하다',
  'auth.register.seoDescription':
    'Grymwyrd 계정을 만들고, 아바타를 일으키며, 당신의 이야기가 정사(定史)가 되게 하세요.',
  'auth.register.eyebrow': 'Greywick 마을을 탐험하다',
  'auth.register.title': '당신의 이야기를 시작하다',
  'auth.register.blurb': '당신은 영원계의 꿈에서 깨어나 눈을 뜹니다…',
  'auth.register.alreadyBound': '이미 황혼에 묶여 있나요?',
  'auth.register.loginToExisting': '기존 계정으로 로그인',
  'auth.register.displayNameLabel': '표시 이름',
  'auth.register.displayNamePlaceholder': '공허한 기사',
  'auth.register.displayNameHint': '이 이름으로 공개 아바타와 기여도가 표시됩니다.',
  'auth.register.emailLabel': '이메일',
  'auth.register.emailPlaceholder': 'you@grymwyrd.com',
  'auth.register.passwordLabel': '비밀번호',
  'auth.register.passwordPlaceholder': '최소 8자 이상',
  'auth.register.agreementsLegend': '약관',
  'auth.register.adultConfirmPrefix': '나는',
  'auth.register.adultConfirmEmphasis': '13세 이상',
  'auth.register.adultConfirmSuffix': '임을 확인합니다.',
  'auth.register.acceptPrefix': '나는',
  'auth.register.termsOfThePact': '계약의 약관',
  'auth.register.acceptSuffix': '에 동의합니다.',
  'auth.register.submitBusy': '계약을 봉인하는 중…',
  'auth.register.submit': '나타나다',
  'auth.register.dividerOr': '또는',
  'auth.register.mockAuthNote': '개발용 모의 인증: 가입은 로컬에서만 유지됩니다. 이메일이 발송되지 않습니다.',
  'auth.register.lastUpdated': '마지막 업데이트 {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': '당신의 계약과 연결된 이메일을 입력해주세요.',
  'auth.reset.seoTitle': '비밀번호 초기화',
  'auth.reset.seoDescription':
    '비밀번호를 잊으셨나요? 일회용 링크를 이메일로 보내드립니다. 클릭해서 새 비밀번호를 정하세요.',
  'auth.reset.eyebrow': '말을 잃다',
  'auth.reset.title': '비밀번호 초기화',
  'auth.reset.blurb':
    '이메일을 속삭이면 어둠 속으로 일회용 링크가 보내집니다. 따라가서 새 비밀번호를 설정하세요.',
  'auth.reset.rememberedAfterAll': '결국 기억나셨나요?',
  'auth.reset.loginToExisting': '기존 계정으로 로그인',
  'auth.reset.successMessage':
    '{email}에 등록된 계정이 있다면, 일회용 링크를 발송했습니다. 열어서 로그인하고 새 비밀번호를 설정하세요 — 이메일과 스팸 폴더를 확인해주세요.',
  'auth.reset.sendToDifferentEmail': '다른 이메일로 전송',
  'auth.reset.emailLabel': '이메일',
  'auth.reset.emailPlaceholder': 'you@grymwyrd.com',
  'auth.reset.submitBusy': '소환하는 중…',
  'auth.reset.submit': '로그인 링크 전송',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': '최소 8자 이상의 비밀번호를 선택해주세요.',
  'auth.setPassword.errorMismatch': '입력된 비밀번호가 일치하지 않습니다.',
  'auth.setPassword.seoTitle': '비밀번호 설정',
  'auth.setPassword.seoDescription': 'Grymwyrd 계정을 위한 새 비밀번호를 정하세요.',
  'auth.setPassword.eyebrow': '계약을 봉인하다',
  'auth.setPassword.title': '새 비밀번호 설정',
  'auth.setPassword.blurb':
    '로그인되었습니다. 새 비밀번호를 정하세요 — 다음에 마법 링크와 함께 사용할 수 있습니다.',
  'auth.setPassword.ratherNot': '원치 않으신가요?',
  'auth.setPassword.skipForNow': '나중에 건너뛰기',
  'auth.setPassword.successMessage': '비밀번호가 설정되었습니다. 성역으로 안내하는 중…',
  'auth.setPassword.newPasswordLabel': '새 비밀번호',
  'auth.setPassword.newPasswordPlaceholder': '최소 8자 이상',
  'auth.setPassword.confirmPasswordLabel': '비밀번호 확인',
  'auth.setPassword.confirmPasswordPlaceholder': '다시 입력',
  'auth.setPassword.submitBusy': '봉인하는 중…',
  'auth.setPassword.submit': '비밀번호 저장',
}
